var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipFilledBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "question",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D6FE0",
    d: "M12 5c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm0 9.8c.387 0 .7.313.7.7 0 .387-.313.7-.7.7-.387 0-.7-.313-.7-.7 0-.387.313-.7.7-.7zM9.326 9.781c.385-1.274 1.659-2.163 3.101-1.953 1.218.182 2.177 1.211 2.345 2.429.189 1.337-.721 1.855-1.393 2.492-.084.077-.161.154-.231.238-.007.007-.014.021-.021.028-.07.084-.14.175-.196.273-.014.021-.021.042-.035.063-.119.21-.196.455-.196.749h-1.4c0-.35.056-.637.14-.875.007-.021.007-.035.014-.049l.028-.056c.049-.126.112-.245.175-.35.007-.014.014-.021.021-.035 0-.007.007-.007.007-.014.581-.875 1.645-1.078 1.715-2.016.056-.679-.434-1.33-1.099-1.47-.721-.154-1.386.273-1.61.896-.098.266-.329.469-.616.469h-.14c-.427 0-.735-.413-.609-.819z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipFilledBlue);
export default __webpack_public_path__ + "static/media/tooltip-filled-blue.0352b91bab73464d157066e39662b1f9.svg";
export { ForwardRef as ReactComponent };